import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { SearchFieldClearButton } from '~/components/Search/SearchFieldClearButton';
import { useAppliedFiltersCount } from '~/hooks/filters/useAppliedFiltersCount';
import { useApplyFilters } from '~/hooks/filters/useApplyFilters';
import { useSearchParams } from '~/hooks/search/useSearchParams';
import { clearAllFiltersAction } from '~/store/filters/actions';

export type PublicSearchActionsProps = {
  onClearSearchValue: () => void;
};

export const PublicSearchActions = memo(({ onClearSearchValue }: PublicSearchActionsProps) => {
  const { search } = useSearchParams();
  const { filtersCount } = useAppliedFiltersCount();
  const { clearSearchAndFilters } = useApplyFilters();
  const dispatch = useDispatch();
  const label = filtersCount > 0 ? 'Clear all' : 'Clear';

  const handleClick = useCallback(() => {
    clearSearchAndFilters();
    dispatch(clearAllFiltersAction());
    onClearSearchValue();
  }, [onClearSearchValue, clearSearchAndFilters, dispatch]);

  if (!filtersCount && !search) {
    return null;
  }

  return <SearchFieldClearButton data-testid="CLEAR_FILTER_BUTTON" label={label} onClick={handleClick} />;
});

PublicSearchActions.displayName = 'PublicSearchActions';
